var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56518 3.18497C9.56518 1.54179 10.8972 0.209717 12.5404 0.209717C14.1836 0.209717 15.5157 1.54178 15.5157 3.18497V4.73422C15.5157 7.23081 17.5396 9.25469 20.0362 9.25469L21.5814 9.2547C23.2246 9.2547 24.5566 10.5868 24.5566 12.23C24.5566 13.8731 23.2246 15.2052 21.5814 15.2052H20.0362C17.5396 15.2052 15.5157 17.2291 15.5157 19.7257V21.2747C15.5157 22.9179 14.1836 24.25 12.5404 24.25C10.8972 24.25 9.56518 22.9179 9.56518 21.2747V19.7276C9.56518 17.2299 7.54043 15.2052 5.04279 15.2052H3.49163C1.84844 15.2052 0.516376 13.8731 0.516376 12.23C0.516376 10.5868 1.84844 9.25469 3.49163 9.25469L5.04269 9.25469C7.54039 9.25469 9.56518 7.22991 9.56518 4.73221V3.18497Z",
    fill: "#001850"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56518 3.18497C9.56518 1.54179 10.8972 0.209717 12.5404 0.209717C14.1836 0.209717 15.5157 1.54178 15.5157 3.18497V4.73422C15.5157 7.23081 17.5396 9.25469 20.0362 9.25469L21.5814 9.2547C23.2246 9.2547 24.5566 10.5868 24.5566 12.23C24.5566 13.8731 23.2246 15.2052 21.5814 15.2052H20.0362C17.5396 15.2052 15.5157 17.2291 15.5157 19.7257V21.2747C15.5157 22.9179 14.1836 24.25 12.5404 24.25C10.8972 24.25 9.56518 22.9179 9.56518 21.2747V19.7276C9.56518 17.2299 7.54043 15.2052 5.04279 15.2052H3.49163C1.84844 15.2052 0.516376 13.8731 0.516376 12.23C0.516376 10.5868 1.84844 9.25469 3.49163 9.25469L5.04269 9.25469C7.54039 9.25469 9.56518 7.22991 9.56518 4.73221V3.18497Z",
    fill: "url(#paint0_linear_3295_6572)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3295_6572",
    x1: 12.5365,
    y1: -5.47911,
    x2: 9.7602,
    y2: 26.3526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.8c93a4f266d89ac24b76f6b6d82c7a12.svg";
export { ForwardRef as ReactComponent };